// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2Xerz","content":"RecentSearches_content__33nED"};